module.exports = __webpack_public_path__ + "images/ad832ccae5b3fb310ab357f06a1d7471-ISLA-COZUMEL-WHITE.png";